<div class="segmented-control-wrapper" [class.size-md]="size === 'md'">
  <span class="toggle-label" *ngIf="label">{{ label }}</span>
  <div class="segmented-control" role="group" [attr.aria-label]="label || 'options'">
    <button
      type="button"
      class="segmented-control-btn"
      *ngFor="let option of options; trackBy: trackByValue"
      [class.active]="value === option.value"
      [disabled]="disabled || option.disabled"
      (click)="select(option)"
    >
      {{ option.label }}
    </button>
  </div>
</div>
